import { usePageView } from '@fs/zion-analytics'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import { deepCopy } from '../../../util/Utils'
import { CtrContext } from '../CtrContext'
import CtrSummaryDetails from './details/CtrSummaryDetails'
import TssOdmData from './tssOdm/TssOdmData'
import CtrOwsSummaryPerson from '../../common/temple/CtrOwsSummaryPerson'
import AddPerson from '../../common/temple/AddPerson'

export default function CtrSummary() {
  usePageView({ page_detail: 'DMConsole:CtrSummary' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.ctr.summary'))
  const ctrContext = useContext(CtrContext)
  const currentCtr = ctrContext.currentCtr
  const ogTemplePlatform = currentCtr ? currentCtr.templePlatform : null
  const [editableTemplePlatform, setEditableTemplePlatform] = useState(deepCopy(ogTemplePlatform))
  const ogCtrExtendedDetail = currentCtr ? currentCtr.ctrExtendedDetail : null
  const [editableCtrExtendedDetail, setEditableCtrExtendedDetail] = useState(deepCopy(ogCtrExtendedDetail))
  const [isEditing, setEditing] = useState(false)
  const [verifiedPersons, setVerifiedPersons] = useState({})
  const [verifiedMembers, setVerifiedMembers] = useState({})

  if (!currentCtr) {
    return null
  }

  return (
    <>
      <CtrSummaryDetails
        ogTemplePlatform={ogTemplePlatform}
        editableTemplePlatform={editableTemplePlatform}
        setEditableTemplePlatform={setEditableTemplePlatform}
        ogCtrExtendedDetail={ogCtrExtendedDetail}
        editableCtrExtendedDetail={editableCtrExtendedDetail}
        setEditableCtrExtendedDetail={setEditableCtrExtendedDetail}
        isEditing={isEditing}
        setEditing={setEditing}
        verifiedPersons={verifiedPersons}
        setVerifiedPersons={setVerifiedPersons}
        verifiedMembers={verifiedMembers}
        setVerifiedMembers={setVerifiedMembers}
      />
      {currentCtr?.tssOdmData && <TssOdmData data={currentCtr.tssOdmData} />}
      {editableTemplePlatform.persons &&
        editableTemplePlatform.persons
          .map((person, ogIndex) => {
            return { person, ogIndex }
          })
          .filter(({ person }) => !person.id.includes('qr.'))
          .map(({ person, ogIndex }) => {
            return (
              <CtrOwsSummaryPerson
                key={`${person.id}-ctr-person`}
                personDataId={person.id}
                personIndex={ogIndex}
                editableTemplePlatform={editableTemplePlatform}
                setEditableTemplePlatform={setEditableTemplePlatform}
                editableCtrExtendedDetail={editableCtrExtendedDetail}
                setEditableCtrExtendedDetail={setEditableCtrExtendedDetail}
                isEditing={isEditing}
                setVerifiedPersons={setVerifiedPersons}
                setVerifiedMembers={setVerifiedMembers}
              />
            )
          })}
      {isEditing && (
        <AddPerson
          editableTemplePlatform={editableTemplePlatform}
          setEditableTemplePlatform={setEditableTemplePlatform}
          editableCtrExtendedDetail={editableCtrExtendedDetail}
          setEditableCtrExtendedDetail={setEditableCtrExtendedDetail}
        />
      )}
    </>
  )
}
